import { render, staticRenderFns } from "./employers-item-match.vue?vue&type=template&id=892830f2"
import script from "./employers-item-match.vue?vue&type=script&lang=js"
export * from "./employers-item-match.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports